import type { TagAppearance } from '@fourthwall/components'

import type { Promotion } from './types'

type Status = {
  label: string
  appearance: TagAppearance
}

export const STATUSES: Record<Promotion['status']['type'], Status> = {
  LIVE: {
    label: 'LIVE',
    appearance: 'success',
  },
  ENDED: {
    label: 'ENDED',
    appearance: 'default',
  },
  ARCHIVED: {
    label: 'ARCHIVED',
    appearance: 'default',
  },
  ALL_USED: {
    label: 'ALL USED',
    appearance: 'default',
  },
}
